import { AxiosError } from "axios";
import { useCallback, useMemo, useState } from "react";
import { useApiErrorDialog } from "../../../../../hooks/utile/use-error-dialog";
import { useParamState } from "../../../../../hooks/utile/use-param-state";
import { useValidation } from "../../../../../hooks/utile/use-validation";
import { Api } from "../../../../../module/api";
import { PasswordResetEmailRequestParam } from "../../../../../module/api/routes/password/reset-email";
import { InputUtile } from "../../../../../module/utile/input-rurules";
import RootStore from "../../../../../store/root.store";
import { CustomButton } from "../../../button/button";

const initialResetRequestState: PasswordResetEmailRequestParam = {
  login_id: '',
  responsible_person_email_address: '',
}

export const usePasswordResetRequest = () => {
  const { dialog } = RootStore;
  const [load, setLoad] = useState(false);
  const [request, setRequest] = useParamState(initialResetRequestState, {
    responsible_person_email_address: InputUtile.email,
  });
  const errDialog = useApiErrorDialog();
  const { validAll } = useValidation();

  const validation = useMemo(() => {
    const {
      login_id,
      responsible_person_email_address,
    } = request;
    return {
      login_id: validAll(login_id, 'require'),
      responsible_person_email_address: validAll(responsible_person_email_address, 'require'),
    }
  }, [request, validAll]);

  const isDisabled = useMemo(() => {
    return !!Object.values(validation).flat().length;
  }, [validation]);

  /* 登録内容と一致したかどうかを判別させないため、送信可否に関わらず同じメッセージを表示する */
  const pushAcceptedMessage = useCallback(() => {
    dialog.pushMessage({
      messages: [
        'パスワードの再発行の申請を受け付けました。',
        '入力された情報が登録内容と一致する場合、パスワード再設定用のメールを送信しています。',
      ],
      buttons: [
        { label: 'OK', callback: () => dialog.clear() },
      ],
    });
  }, [dialog]);

  const onClickSubmit = useCallback(() => {
    setLoad(true);
    Api.connect().password().resetEmail().post(request)
    .then(() => pushAcceptedMessage())
    .catch((e) => {
      const status = (e as AxiosError)?.response?.status;
      /* サーバーエラー以外は入力内容の不一致と区別させないため、受付メッセージを表示する */
      if (status && status < 500) {
        pushAcceptedMessage();
        return;
      }
      errDialog.push(e);
    })
    .finally(() => setLoad(false));
  }, [request, errDialog, pushAcceptedMessage]);

  const onClickCancel = useCallback(() => {
    dialog.pop();
  }, [dialog]);

  const Footer = () => {
    return (
      <>
        <CustomButton
          colorType="secondary"
          onClick={onClickCancel}
          isDisabled={load}
        >
          キャンセル
        </CustomButton>
        <CustomButton
          onClick={onClickSubmit}
          isDisabled={isDisabled || load}
        >
          送信
        </CustomButton>
      </>
    )
  }

  return {
    Footer,
    request,
    setRequest,
    validation,
  }
}
